import { render } from "./legoTableExpand.vue?vue&type=template&id=f64f7000&scoped=true"
import script from "./legoTableExpand.vue?vue&type=script&lang=js"
export * from "./legoTableExpand.vue?vue&type=script&lang=js"

import "./legoTableExpand.vue?vue&type=style&index=0&id=f64f7000&lang=scss&scoped=true"
import "./legoTableExpand.vue?vue&type=style&index=1&id=f64f7000&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64f7000"],['__file',"src/components/lego/extend/legoTableExpand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f64f7000"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f64f7000', __exports__)) {
    api.reload('f64f7000', __exports__)
  }
  
  module.hot.accept("./legoTableExpand.vue?vue&type=template&id=f64f7000&scoped=true", () => {
    api.rerender('f64f7000', render)
  })

}


export default __exports__